import React, { useState } from 'react';
import './DailyNeeds.css';

const DailyNeeds = () => {

  const [input, setInput] = useState({})
  const [dataitem, setDataitem] = useState([])
  const [toggle, setToggle] = useState(true)
  const [id, setId] = useState()


  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInput(values => ({ ...values, [name]: value }))
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    if (toggle) {
      setDataitem([...dataitem, input])
      setInput({})
    }
    else {
      dataitem.splice(id, 1, input)
      setDataitem(dataitem)
      setToggle(true)
      setInput({})
    }
  }

  const handleDelete = (id) => {
    const newdata = dataitem.filter((curelem, index) => {
      return (id !== index)
    })
    setDataitem(newdata)
  }

  const handleEdit = (curId) => {
    const editdata = dataitem.find((elem, index) => {
      return (index === curId)
    })
    setInput(editdata)
    setToggle(false)
    setId(curId)
  }


  return (
    <div>
      <div className='row maincss'>
        <i><h1 className='h1text'>DAILY EXPENSES LIST</h1></i>
        <div>
          <form onSubmit={handleSubmit}>
            <input className='inputname' type="text" placeholder="Item" name="Item" value={input.Item || ""} onChange={handleChange} />
            <input className='inputname' type="number" placeholder="Price" name="Price" value={input.Price || ""} onChange={handleChange} />
            <input className='inputname' type="text" name="Date" placeholder="DD-MM-YYYY" required  value={input.Date || ""} onChange={handleChange} />
            {toggle ?
              <button class="btn buton btn-primary" type="submit" >Save</button> :
              <button class="btn buton btn-primary" type="submit" >Update</button>
            }
          </form>
        </div>
        <div class="row  mainc">
          {dataitem.map((object, index) => {
            return (
              <div class="card crdd" style={{ width: "300px" }}>
                <h5 class="card-header">{object.Item}</h5>
                <div class="card-body">
                  <h5 class="card-title">Rs. {object.Price}</h5>
                  <p class="card-text">{object.Date}</p>
                  <button class="btn butn btn-primary" onClick={() => handleDelete(index)} >Delete</button>
                  <button class="btn butn btn-primary" onClick={() => handleEdit(index)} >Edit</button>
                </div>
              </div>
            )
          })}
        </div>
      </div>

    </div>
  )
}

export default DailyNeeds;